var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOptionsColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19718_466113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0597 6.10986C20.5544 6.10986 20.9543 6.51067 20.9543 7.00452C20.9543 7.49837 20.5544 7.89917 20.0597 7.89917H13.5978C13.1039 7.89917 12.7031 7.49837 12.7031 7.00452C12.7031 6.51067 13.1039 6.10986 13.5978 6.10986H20.0597Z",
    fill: "#C6E1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.86142 16.0945H11.3242C11.8189 16.0945 12.2188 16.4953 12.2188 16.9891C12.2188 17.483 11.8189 17.8838 11.3242 17.8838H4.86142C4.36759 17.8838 3.9668 17.483 3.9668 16.9891C3.9668 16.4953 4.36759 16.0945 4.86142 16.0945Z",
    fill: "#C6E1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.91918 6.89863C9.91918 8.54211 8.58259 9.87872 6.94005 9.87872C5.29751 9.87872 3.96094 8.54211 3.96094 6.89863C3.96094 5.25605 5.29751 3.91943 6.94005 3.91943C8.58259 3.91943 9.91918 5.25605 9.91918 6.89863Z",
    fill: "#3694FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.002 17.1036C15.002 15.4601 16.3385 14.1235 17.9811 14.1235C19.6245 14.1235 20.9611 15.4601 20.9611 17.1036C20.9611 18.7462 19.6245 20.0828 17.9811 20.0828C16.3385 20.0828 15.002 18.7462 15.002 17.1036Z",
    fill: "#3694FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19718_466113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionsColor);
export default __webpack_public_path__ + "static/media/options_color.c3d4cc7ec47d4ec488cb3fd144c2219b.svg";
export { ForwardRef as ReactComponent };